'use strict';

var $ = require('jquery');
var util = require('./util');

var smoothscrolling = {
    /**
     * @function
     * @description
     */
    init: function () {
        var $smoothScrollingElements = $('.smooth-scrolling');
        if ($smoothScrollingElements.length) {
            $smoothScrollingElements.each(function () {
                $(this).on('click', function (e) {
                    e.preventDefault();

                    let offset;
                    let $this = $(this);

                    if ($this.hasClass('back-to-top')) {
                        offset = 0;
                    } else {
                        offset = $($this.attr('href')).offset().top;
                    }

                    util.scrollBrowser(offset, true);
                });
            });
        }
    }
};

module.exports = smoothscrolling;
